import { render, staticRenderFns } from "./gljForm.vue?vue&type=template&id=25e3052c&"
import script from "./gljForm.vue?vue&type=script&lang=js&"
export * from "./gljForm.vue?vue&type=script&lang=js&"
import style0 from "./gljForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "gljForm.vue"
export default component.exports